import React from 'react';

interface ProfileIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
  className?: string;
}

export const ProfileIcon: React.FC<ProfileIconProps> = ({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className = ''
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.011 19.166C5.18285 16.5603 7.3508 14.5 10 14.5H14C16.6457 14.5 18.8114 16.5548 18.9883 19.1556M12 22C17.5229 22 22 17.5229 22 12C22 6.47715 17.5229 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5229 6.47715 22 12 22ZM12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.6193 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.6193 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ProfileIcon;